document.querySelectorAll('.js-toggle-accordion').forEach(($toggle) => {
  const $header = $toggle.closest('.accordion__header');
  let isDesktop = window.matchMedia('(min-width: 1025px)').matches;
  let headerIsSticky = false;
  let headerHeight = isDesktop ? 158 : 80;

  if ($header) {
    const observer = new IntersectionObserver(
      ([e]) => {
        headerIsSticky = e.intersectionRatio < 1;
        headerHeight = isDesktop ? 158 : 80;
      },
      {
        threshold: [1],
        rootMargin: `-${headerHeight}px 0px 0px 0px`,
      }
    );

    observer.observe($header);
  }

  $toggle.addEventListener('click', (event) => {
    const $target = event.currentTarget;

    if ($target) {
      const $accordionPanel = $target.closest('.accordion__item');
      const accordionContentVisible =
        $toggle.getAttribute('aria-expanded') === 'true';
      const $content = document.getElementById(
        $toggle.getAttribute('aria-controls')
      );
      isDesktop = window.matchMedia('(min-width: 1025px)').matches;

      // Switch aria state
      $toggle.setAttribute(
        'aria-expanded',
        (!accordionContentVisible).toString()
      );
      const contentClass = $content.classList[0];
      // Switch content visiblity
      if (accordionContentVisible) {
        $content.classList.remove(`${contentClass}--visible`);
        $accordionPanel.classList.remove('accordion__item--open');
        if (headerIsSticky) {
          $toggle?.closest('.accordion__item').scrollIntoView({
            behavior: 'smooth',
          });
        }
      } else {
        $content.classList.add(`${contentClass}--visible`);
        $accordionPanel.classList.add('accordion__item--open');
      }

      // Dispatch event to reinitialize overlays or sliders
      const selectTabEvent = new CustomEvent('selectTab', {
        bubbles: true,
      });

      $toggle.dispatchEvent(selectTabEvent);
    }
  });
});

export function openAccordionIfItemIsInside($item) {
  if ($item) {
    const $accordionPanel = $item.closest('.accordion__item');

    if ($accordionPanel) {
      const $toggleButton = $accordionPanel.querySelector(
        '.js-toggle-accordion'
      );
      const $toggleContentId = $toggleButton.getAttribute('aria-controls');
      const $toggleContent = document.getElementById($toggleContentId);

      if ($toggleButton && $toggleContent) {
        $toggleButton.setAttribute('aria-expanded', 'true');
        $toggleContent.classList.add('accordion__content--visible');
        $accordionPanel.classList.add('accordion__item--open');
      }
    }
  }
}

function openAccordionByHash(hash) {
  const $toggleTarget = document.getElementById(hash);

  if (
    $toggleTarget &&
    $toggleTarget.parentNode.classList.contains('accordion__item')
  ) {
    const $toggleButton = $toggleTarget.querySelector('.js-toggle-accordion');
    const $toggleContentId = $toggleButton.getAttribute('aria-controls');
    const $toggleContent = document.getElementById($toggleContentId);

    $toggleButton.setAttribute('aria-expanded', 'true');
    $toggleContent.classList.add('accordion__content--visible');
    $toggleContent.focus();
  }
}

if (window.location.hash.substr(1)) {
  openAccordionByHash(window.location.hash.substr(1));
}

window.addEventListener(
  'hashchange',
  () => {
    const hash = window.location.hash.substr(1);
    openAccordionByHash(hash);
  },
  false
);

export default openAccordionIfItemIsInside;
